export default __webpack_public_path__ + "static/media/LY.586502b7.svg";